import React from 'react';
import Toggle from './Toggle';

const DeckSteps = ({ onChange, isChecked }) => {
  return (
    <div className="field conditional" id="conditional_deck_steps">
      <div className="field deck_steps">
        <label className="field_label" htmlFor="deck_steps">Steps</label>
        <span className="field_description">Will the deck need steps? (Note: Deck height is required if steps are added)</span>
        <Toggle onChange={e => onChange(e, 'steps')} isChecked={isChecked} name="deck_steps"/>
      </div>
      {isChecked && (
          <div className="field">
              <label htmlFor="deck_height">Deck Height (ft)</label>
              <input
                  id="deck_height"
                  type="number"
                  min="0"
                  name="deck_height"
                  onChange={e => onChange(e.target.value, 'height')}
              />
          </div>
      )}
    </div>
  );
};

export default DeckSteps;